import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { GlobalDropOverlay } from './GlobalDropOverlay';
import { CommandPalette } from '@/components/palette/CommandPalette';
import { AgentPanel } from '@/components/agent/AgentPanel';
import { useApp } from '@/store/app';

export function AppLayout() {
  const { togglePalette, toggleAgent, theme, setTheme } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const meta = e.metaKey || e.ctrlKey;
      if (meta && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        togglePalette();
      } else if (meta && e.key.toLowerCase() === 'j') {
        e.preventDefault();
        toggleAgent();
      } else if (meta && e.shiftKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        setTheme(theme === 'dark' ? 'light' : 'dark');
      } else if (meta && e.key === '/') {
        e.preventDefault();
        navigate('/');
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [togglePalette, toggleAgent, setTheme, theme, navigate]);

  return (
    <div className="flex h-screen overflow-hidden bg-bg text-fg">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 relative">
        <TopBar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <AgentPanel />
      <GlobalDropOverlay />
    </div>
  );
}
